import React from 'react';
import { SvgIcon } from '@mui/material';

export default function CalendarDeskIcon(props) {
  return (
    <SvgIcon sx={{ width: 48, height: 48 }} {...props}>
      <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          opacity="0.5"
          d="M41.7665 39.3774C41.508 39.7081 33.1338 39.3774 33.1338 39.3774L37.4172 16.459C37.4172 16.459 42.025 39.0467 41.7665 39.3774Z"
          fill="white"
        />
        <path
          d="M13.4501 10.8655H10.7188C10.4012 10.8955 9.75327 11.1944 9.70163 12.1498C9.64999 13.1052 9.68011 15.719 9.70163 16.9064M9.70163 16.9064C9.70163 16.9064 7.40723 37.5891 7.51543 38.2925C7.62363 38.9959 33.7694 39.247 34.0867 38.2925C34.4039 37.338 36.6789 16.9064 36.6789 16.9064M9.70163 16.9064H36.6789M36.6789 16.9064V12.2279C36.6789 11.2326 35.8721 10.4258 34.8768 10.4258H30.7023"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M31.2781 8.625C30.4144 8.91345 29.4057 11.2907 29.55 12.1543"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M17.9568 8.625C17.0931 8.91345 16.0844 11.2907 16.2287 12.1543"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M16.7334 10.7148H27.4625"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <line
          x1="14.2305"
          y1="21.4707"
          x2="14.9489"
          y2="21.4707"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <line
          x1="14.2305"
          y1="27.0859"
          x2="14.9489"
          y2="27.0859"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <line
          x1="14.2305"
          y1="33.0645"
          x2="14.9489"
          y2="33.0645"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <line
          x1="18.9414"
          y1="21.4707"
          x2="19.6598"
          y2="21.4707"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <line
          x1="18.9414"
          y1="27.0859"
          x2="19.6598"
          y2="27.0859"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <line
          x1="18.9414"
          y1="33.0645"
          x2="19.6598"
          y2="33.0645"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <line
          x1="23.6543"
          y1="21.4707"
          x2="24.3727"
          y2="21.4707"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <line
          x1="23.6543"
          y1="27.0859"
          x2="24.3727"
          y2="27.0859"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <line
          x1="23.3199"
          y1="33.3989"
          x2="24.7071"
          y2="33.3989"
          stroke="white"
          strokeWidth="0.831183"
          strokeLinecap="round"
        />
        <line
          x1="28.3662"
          y1="21.4707"
          x2="29.0846"
          y2="21.4707"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <line
          x1="28.0318"
          y1="27.4203"
          x2="29.419"
          y2="27.4203"
          stroke="white"
          strokeWidth="0.831183"
          strokeLinecap="round"
        />
        <line
          x1="28.0318"
          y1="33.3989"
          x2="29.419"
          y2="33.3989"
          stroke="white"
          strokeWidth="0.831183"
          strokeLinecap="round"
        />
        <circle
          cx="28.7249"
          cy="33.3792"
          r="2.46555"
          stroke="#29EDFF"
          strokeWidth="0.831183"
        />
        <circle
          cx="28.7671"
          cy="32.689"
          r="8.04987"
          fill="#29EDFF"
          stroke="#4520AB"
          strokeWidth="1.27819"
        />
        <path
          d="M29.6551 33.6141H25.6718V32.7715H29.6551C30.0228 32.7715 30.3267 32.7076 30.5667 32.58C30.8067 32.4497 30.9854 32.2736 31.1029 32.0514C31.2204 31.8267 31.2791 31.5714 31.2791 31.2854C31.2791 30.9994 31.2204 30.7453 31.1029 30.5232C30.9854 30.2985 30.8067 30.1223 30.5667 29.9946C30.3267 29.8644 30.0228 29.7993 29.6551 29.7993H27.8626V36.8008H26.9127V28.9567H29.6551C30.2373 28.9567 30.7173 29.0626 31.0952 29.2746C31.4732 29.4865 31.754 29.7686 31.9379 30.121C32.1217 30.4734 32.2136 30.8615 32.2136 31.2854C32.2136 31.7093 32.1217 32.0974 31.9379 32.4497C31.754 32.8021 31.4732 33.0843 31.0952 33.2962C30.7173 33.5081 30.2373 33.6141 29.6551 33.6141ZM29.5938 34.3495V35.1921H25.6718V34.3495H29.5938Z"
          fill="#4520AB"
        />
      </svg>
    </SvgIcon>
  );
}
